@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (ListResourceClosings && AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto">
    <div class="text-900 font-medium text-xl mb-3"><h3>{{showAdjustments ? 'Resource Closings and Adjustments' : 'Resource Closings'}}</h3></div>
    <app-tabview [(activeIndex)]="activeTabIndex" [style]="{'width':'100%'}">
      <app-tabpanel header="Resource Closings" leftIcon="pi pi-lock">
        <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
          <span class="pi pi-info-circle" style="margin-right:2px;"></span>
          Resource Closings allow you to specify any temporary closings for a resource for example, you doing maintenance on a resource.
        </p>
        <div class="list-toolbar" style="text-align: right; margin-bottom: 20px;">
          <p-togglebutton class="p-component" [(ngModel)]="isDisabled" onLabel="Show Disabled" offLabel="Hide Disabled" offIcon="pi pi-times" onIcon="pi pi-check" [style]="{'margin-right': '10px', 'color' : 'white', 'background-color': '#EF4444', 'font-weight': 'normal', 'height': '50px'}" (click)="toggleDisabled()">
          </p-togglebutton>
          <span class="p-input-icon-left ml-auto" style="margin-right:20px; ">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="resourceClosingsTable.filterGlobal($event.target.value, 'contains')" style="height: 50px;padding-left:33px;" placeholder="Closing Name"/>
          </span>
          <button pButton type="button" style="height: 50px;" class="p-button-sm p-element p-ripple p-button-success p-button p-component" [routerLink]="['/resourceclosingsedit/0']" i18>
            <span class="pi pi-plus" style="margin-right:8px;"></span>
            <span i18>Add</span>
          </button>
          &nbsp;
          <button pButton type="button" style="height: 50px;" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" (click)="disableMulti()">
            <span class="pi pi-trash" style="margin-right:8px;"></span>
            <span i18>Disable</span>
          </button>
        </div>
        <div class="surface-card p-4 shadow-2 border-round">
          <p-table #resourceClosingsTable
            [value]="ListResourceClosings.data"
            dataKey="id"
            sortField="name"
            [paginator]="true"
            [rows]="10"
            [showCurrentPageReport]="true"
            responsiveLayout="scroll"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            [rowsPerPageOptions]="[10,25,50]"
            [globalFilterFields]="['name']"
            styleClass="p-datatable-striped">
            <ng-template #header>
              <tr>
                <th>
                  <p-checkbox [binary]="true" [(ngModel)]="allClosingsSelected" (onChange)="toggleAllClosings($event.checked)"></p-checkbox>
                </th>
                <th pSortableColumn="name" width="60%">Name <p-sorticon field="name"></p-sorticon>
              </th>
              <th pSortableColumn="startdate" width="15%">Start Date <p-sorticon field="startdate"></p-sorticon>
            </th>
            <th pSortableColumn="enddate" width="15%">End Date <p-sorticon field="enddate"></p-sorticon>
          </th>
          <th width="10%" style="text-align:center;">Closing Based on Day</th>
          <th width="5%"></th>
          <th width="5%"></th>
        </tr>
      </ng-template>
      <ng-template #body let-data>
        <tr [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
          <td>
            <p-checkbox name="groupname" [(ngModel)]="selectedItems" value="{{data.resourceclosingid}}"></p-checkbox>
          </td>
          <td>{{data.name}}</td>
          <td>{{data.startdate | date:'dd/MM/yyyy HH:mm' : "UTC"}}</td>
          <td>{{data.enddate | date:'dd/MM/yyyy HH:mm' : "UTC"}}</td>
          <td style="text-align:center;">
            @if (data.closingbasedonday) {
              <span class="pi pi-check" style="color:green;"></span>
            }
            @if (!data.closingbasedonday) {
              <span class="pi pi-times" style="color:red;"></span>
            }
          </td>
          <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" style="background-color: yellow o !important;" (click)="editData(data.resourceclosingid);" i18>
            <span class="pi pi-pencil" style="margin-right:8px;"></span>
            <span i18n>Edit</span>
          </button></td>
          <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" style="margin-left:-20px;"  (click)="disableData(data.resourceclosingid)" i18>
            <span class="pi pi-trash" style="margin-right:8px;"></span>
            <span i18n>Disable</span>
          </button></td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</app-tabpanel>
@if (showAdjustments) {
  <app-tabpanel header="Resource Adjustments" leftIcon="pi pi-minus-circle">
    <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
      <span class="pi pi-info-circle" style="margin-right:2px;"></span>
      Resource Adjustments allow you to temporarily change the capacity of a resource for a period - either set a new capacity, higher or lower, or reduce it by an amount.
    </p>
    <div class="list-toolbar" style="text-align: right; margin-bottom: 20px;">
      <p-togglebutton class="p-component" [(ngModel)]="isReductionDisabled" onLabel="Show Disabled" offLabel="Hide Disabled" offIcon="pi pi-times" onIcon="pi pi-check" [style]="{'margin-right': '10px', 'color' : 'white', 'background-color': '#EF4444', 'font-weight': 'normal', 'height': '50px'}" (click)="toggleReductionDisabled()">
      </p-togglebutton>
      <span class="p-input-icon-left ml-auto" style="margin-right:20px; ">
        <i class="pi pi-search"></i>
        <input pInputText type="text" (input)="resourceReductionsTable.filterGlobal($event.target.value, 'contains')" style="height: 50px;padding-left:33px;" placeholder="Adjustment Name"/>
      </span>
      <button pButton type="button" style="height: 50px;" class="p-button-sm p-element p-ripple p-button-success p-button p-component" [routerLink]="['/resourcereductionsedit/0']">
        <span class="pi pi-plus" style="margin-right:8px;"></span>
        <span>Add</span>
      </button>
      &nbsp;
      <button pButton type="button" style="height: 50px;" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" (click)="disableMultiReductions()">
        <span class="pi pi-trash" style="margin-right:8px;"></span>
        <span>Disable</span>
      </button>
    </div>
    <div class="surface-card p-4 shadow-2 border-round">
      <p-table #resourceReductionsTable
        [value]="$safeNavigationMigration(ListResourceReductions?.data)"
        dataKey="id"
        sortField="name"
        [paginator]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        responsiveLayout="scroll"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        [rowsPerPageOptions]="[10,25,50]"
        [globalFilterFields]="['name']"
        styleClass="p-datatable-striped">
        <ng-template #header>
          <tr>
            <th>
              <p-checkbox [binary]="true" [(ngModel)]="allReductionsSelected" (onChange)="toggleAllReductions($event.checked)"></p-checkbox>
            </th>
            <th pSortableColumn="name" width="45%">Name <p-sorticon field="name"></p-sorticon>
          </th>
          <th pSortableColumn="startdate" width="15%">Start Date <p-sorticon field="startdate"></p-sorticon>
        </th>
        <th pSortableColumn="enddate" width="15%">End Date <p-sorticon field="enddate"></p-sorticon>
      </th>
      <th pSortableColumn="adjustmentamount" width="10%" style="text-align:center;">Adjustment <p-sorticon field="adjustmentamount"></p-sorticon></th>
      <th width="10%" style="text-align:center;">Adjustment Based on Day</th>
      <th width="5%"></th>
      <th width="5%"></th>
    </tr>
  </ng-template>
  <ng-template #body let-data>
    <tr [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
      <td>
        <p-checkbox name="reductiongroup" [(ngModel)]="selectedReductionItems" value="{{data.resourcereductionid}}"></p-checkbox>
      </td>
      <td>{{data.name}}</td>
      <td>{{data.startdate | date:'dd/MM/yyyy HH:mm' : "UTC"}}</td>
      <td>{{data.enddate | date:'dd/MM/yyyy HH:mm' : "UTC"}}</td>
      <td style="text-align:center;">{{data.adjustmenttype == 'NEWCAPACITY' ? 'New capacity ' : 'Reduce by '}}{{data.adjustmentamount}}</td>
      <td style="text-align:center;">
        @if (data.reductionbasedonday) {
          <span class="pi pi-check" style="color:green;"></span>
        }
        @if (!data.reductionbasedonday) {
          <span class="pi pi-times" style="color:red;"></span>
        }
      </td>
      <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" (click)="editReduction(data.resourcereductionid);">
        <span class="pi pi-pencil" style="margin-right:8px;"></span>
        <span>Edit</span>
      </button></td>
      <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" style="margin-left:-20px;"  (click)="disableReduction(data.resourcereductionid)">
        <span class="pi pi-trash" style="margin-right:8px;"></span>
        <span>Disable</span>
      </button></td>
    </tr>
  </ng-template>
</p-table>
</div>
</app-tabpanel>
}
</app-tabview>
</div>
}
